
import { json } from './../utility/dom'


var loaded = false,
	loading = false,
	callbacks = [],
	mapPin = '',
	isDraggable = (document.documentElement.clientWidth > 480),
	mapOptions = {
		zoom: 15,
	    draggable: isDraggable,
	    panControl : false, // left right up down circle
	    scrollwheel: false, // scrollwheel zoom
	    zoomControl : true, // + - controls
	    streetViewControl : true,
	    mapTypeControl: false,
	    overviewMapControl: false,
	    styles: [{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#d3d3d3"}]},{"featureType":"transit","stylers":[{"color":"#808080"},{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#b3b3b3"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"weight":1.8}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#d7d7d7"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ebebeb"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#a7a7a7"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#efefef"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#696969"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#737373"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#d6d6d6"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#dadada"}]}]
	};


function loadGmapsJS(callback) {
 
	if (callback && loaded) return callback()
	if (callback) callbacks.push(callback)

	// load
	if (!loading && !loaded) {
		loading = true

		var script = document.createElement('script')
		script.type = 'text/javascript'
		script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCbuwPyam-uUxEkhkCs82WrFFESj6NkF3I&callback=googlemapInitialize'
		
		window.googlemapInitialize = function() {
			loading = false
			loaded = true
			for (var i = 0; i < callbacks.length; i++) {
				callbacks[i]()
			}
		}

		document.body.appendChild(script)
	}
}


function init(mapEl) {

	let gmap

	let lat = mapEl.getAttribute('data-lat')
	let lng = mapEl.getAttribute('data-lng')
	let name = mapEl.getAttribute('data-name')

	if (!lat || !lng) return

	loadGmapsJS(function() {
		mapEl.classList.add('loaded')

		mapOptions.center = new google.maps.LatLng(lat, lng)
		gmap = new google.maps.Map(mapEl, mapOptions)
		new google.maps.Marker({
            position: mapOptions.center,
            name : name,
            map: gmap,
            icon: mapPin
		})
	})
}


export default () => {

	const maps = [...document.querySelectorAll('.js-contact-map')]
	if (maps.length) {
		const siteSettings = json('#site-settings')
		mapPin = siteSettings.templateUri + "/assets/img/gmaps-pin.svg";
	}
	maps.map(map => init(map))
}



